<template>
  <Main>
    <template v-slot:breadcrumb>
      <BaseBreadcrumb
        @return="previousPage"
        :items="breadcrumb"
        class="d-none d-sm-flex"
      />
    </template>
    <template v-slot:breadcrumb-mobile>
      <BaseBreadcrumb @return="previousPage" :items="breadcrumb" />
    </template>
    <v-row>
      <v-col cols="12">
        <p class="historic-limit__title primary--text mb-6">
          HISTÓRICO DE LIMITES
        </p>
      </v-col>
    </v-row>
    <fragment v-if="itemsHistoric">
      <HistoricLimitItem
        v-for="(element, key) in itemsHistoric"
        :key="key"
        :item="element"
      />
    </fragment>
  </Main>
</template>
<script>
import { mapActions, mapState } from "vuex";
import HistoricLimitItem from "../components/HistoricLimitItem";
import { LoadingRequest } from "@/mixins/LoadingMixin";
export default {
  data: () => ({
    breadcrumb: [
      {
        text: "Seguradora",
        to: "economic_group view"
      }
    ]
  }),
  mixins: [LoadingRequest],
  components: {
    HistoricLimitItem
  },
  created() {
    this.fetchData();
  },
  computed: {
    ...mapState("economic_group", ["itemsHistoric", "creditLimitConsult"]),
    groupId() {
      return this.$route.params.groupId;
    },
    consultId() {
      return this.$route.params.consultId;
    }
  },
  methods: {
    ...mapActions("economic_group", [
      "requestHistoricLimit",
      "findCreditLimitConsult"
    ]),
    previousPage() {
      this.$router.push({
        name: "economic_group credit_limit consult",
        params: { groupId: this.groupId, consultId: this.consultId }
      });
    },
    fetchData() {
      const { groupId, consultId } = this;
      if (this.creditLimitConsult) {
        this.fetchHistoric(this.creditLimitConsult.seguradora.id);
      } else {
        this.withLoading(this.findCreditLimitConsult({ groupId, consultId }));
      }
    },
    fetchHistoric(insurance) {
      const { groupId } = this;
      this.withLoading(this.requestHistoricLimit({ groupId, insurance }));
    }
  },
  watch: {
    creditLimitConsult(value) {
      this.fetchHistoric(value.seguradora.id);
      this.breadcrumb = [
        {
          text: `Seguradora ${value.seguradora.nome}`,
          to: "economic_group view"
        }
      ];
    }
  }
};
</script>
<style lang="sass">
.historic-limit__
  &title
    font-weight: 800
    font-size: 18px
</style>
